//
import { API } from "../../api";
async function remove_products(request) {
    // console.log("remove_multiple_products -> request", request);
    return await new API().apiPut({
        baseUrl: process.env.LETS_TRADE_BASKET_URL ?? "",
        endpoint: `v2/remove/products`, //
        content: request,
    });
}
export { 
// IRemoveMultipleProductsRequest,
remove_products, };
